import { scan } from 'react-scan'; // must be imported before React and React DOM

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { reportWebVitals } from './reportWebVitals';
import './i18n/i18n';
import './index.css';
import { LicenseInfo } from '@mui/x-license-pro';
import { envVariables } from 'src/common/utils/envVariables';

scan({
  enabled: true,
});

LicenseInfo.setLicenseKey(envVariables.VITE_MUI_PRO_KEY || '');

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

reportWebVitals();
